import i18n from 'i18n';
import { getDateWithFormat } from 'utils/dateUtil';

export const t = (key: string, opts?: any) => i18n.t(`transactions:versionHistory.${key}`, opts);

// created/updated arrive from the API as epoch SECONDS (BlazeSvOffsetDateTimeSerializer -> toEpochSecond()).
// Delegate to the shared formatter, which converts seconds -> ms and matches the rest of the app's date format.
// (A raw `new Date(seconds)` treats the value as milliseconds and renders 1/21/1970 — MOB-52612.)
export const formatWhen = (value?: string | number): string => (value ? getDateWithFormat(value) : '');
